// Forms submitted by the browser itself, not by Turbo: the iOS Share Extension
// turns Turbo Drive off (see ShareViewController in listy-ios). Turbo disables
// the submit button of the submissions it handles; nothing did for these, and
// data-disable-with is a rails-ujs attribute, which isn't installed. A second
// tap on "Ajouter" posted the form again: the same product added twice.
//
// Once a submission is certain to leave natively, its button is disabled and
// relabelled (an input's label is its value) — only when it opts in with
// data-disable-with, as with rails-ujs. Not every native submission leaves the
// page: a method="dialog" form only closes its <dialog>, a download or a
// target="_blank" form keeps the page on screen. Disabled regardless, their
// buttons stayed dead: the Turbo confirmation modal lost "Confirmer" and its
// close button after one use (#389).
document.addEventListener('submit', (event) => {
  // Next task: every listener has run. A prevented submission is one Turbo, or
  // a controller holding it back (scraper#submit waiting on the phone), took over.
  setTimeout(() => {
    const { submitter } = event
    if (event.defaultPrevented || !submitter?.dataset.disableWith) return

    submitter.disabled = true
    submitter.dataset.enableWith = submitter.value
    submitter.value = submitter.dataset.disableWith
  })
})

// Back to a page restored from the back/forward cache (a validation error, then
// the back button): the button would still be disabled.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return

  document.querySelectorAll('[data-enable-with]').forEach((submitter) => {
    submitter.disabled = false
    submitter.value = submitter.dataset.enableWith
    delete submitter.dataset.enableWith
  })
})
